import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom';
import React, { useEffect } from 'react';
export const RedirectPage = () => {
  const pageLocation = useLocation();
  const history = useHistory();
  
  useEffect(() => {
    const queryParams = new URLSearchParams(pageLocation.search);
    const redirectUri = queryParams.get('redirectUri');
    if (redirectUri) {
      history.replace(redirectUri);
    } else {
      history.replace('/');
    }
  });
  return (<></>);
};